import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5625 3.5C18.2677 3.5 19.65 4.88232 19.65 6.5875L20.6 17.5125C20.6 19.2177 19.2177 20.6 17.5125 20.6H6.5875C4.88232 20.6 3.5 19.2177 3.5 17.5125L4.45 6.5875C4.45 4.88232 5.83232 3.5 7.5375 3.5H16.5625Z"
      stroke="#262626"
      stroke-width="2"
    />
    <path
      d="M15.5054 7.39999C15.5054 9.30683 13.9596 10.8526 12.0527 10.8526C10.1459 10.8526 8.6001 9.30683 8.6001 7.39999"
      stroke="#262626"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.45023 6.49358C3.47378 4.28396 5.27231 2.5 7.4875 2.5H16.5125C18.7277 2.5 20.5262 4.28396 20.5498 6.49358L21.5 17.4213V17.4625C21.5 19.6923 19.6923 21.5 17.4625 21.5H6.5375C4.30765 21.5 2.5 19.6923 2.5 17.4625V17.4213L3.45023 6.49358Z"
      fill="url(#paint0_linear_19103_13820)"
    />
    <path
      d="M15.5054 7.39999C15.5054 9.30683 13.9596 10.8526 12.0527 10.8526C10.1459 10.8526 8.6001 9.30683 8.6001 7.39999"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_19103_13820"
        x1="5.5"
        y1="3.9976"
        x2="20.9744"
        y2="19.9968"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconSystem() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
